import {inject, Injectable} from '@angular/core';
import {DcpDataService} from '@app/services/analytics/dcp-data.service';
import {CxEvent} from '@spartacus/core';
import {EddlProductViewEvent} from '@app/services/analytics/EDDL/events/eddl-product-view-event';
import {
  EDDL_STORAGE_HELPER_NAME,
  EddlAdobeTrackingData,
  EddlProductFindingMethods, EddlSessionHelperContent
} from '@app/services/analytics/EDDL/models/eddl-adobe-tracking-data';
import {SessionStorageService} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class DcpEddlProductViewService extends DcpDataService<EddlAdobeTrackingData> {

  private sessionStorageService = inject(SessionStorageService);

  constructor() {
    super()
  }

  fillData(event: EddlProductViewEvent, data?: EddlAdobeTrackingData): EddlAdobeTrackingData {
    if (!data) {
      data = {};
    }

    data.event = 'productView';

    if (!data.ecommerce && event.products?.length > 0) {
      data.ecommerce = {};
      data.ecommerce.products = [];

      event.products.forEach(prod => {
        data.ecommerce.products.push({
          ...prod,
          findingMethod: prod.findingMethod ?? EddlProductFindingMethods.SITE_NAVIGATION
        })
      })
    }

    return data;
  }

  getData(event: CxEvent): EddlAdobeTrackingData {
    if (!(event instanceof EddlProductViewEvent)) {
      return undefined;
    }

    return this.fillData(this.checkExtrasInSession(event))

  }

  private checkExtrasInSession(event: EddlProductViewEvent): EddlProductViewEvent {
    const existedSession = this.sessionStorageService.getItem(EDDL_STORAGE_HELPER_NAME);

    if (existedSession) {
      const existedParsedSession: EddlSessionHelperContent[] = JSON.parse(existedSession);
      const pve = existedParsedSession
        .find(session => session.uniqueToken === event.collectToken)
        ?.extras.find((extra => extra.event === event.constructor.name));

      if (pve) {
        (event as EddlProductViewEvent) = {
          ...event,
          products: event.products.map(p => ({
            ...p,
            findingMethod: pve.hasOwnProperty('findingMethod') ? pve.findingMethod : EddlProductFindingMethods.SITE_NAVIGATION
          }))
        }
      }
    }
    return event;
  }
}
